/**
 * Fusion profonde pour les JSON marketing : les objets se fusionnent récursivement,
 * les tableaux et feuilles du patch remplacent celles de la base.
 */
export function mergePublicLocale<T>(base: T, patch: unknown): T {
  if (patch === null || patch === undefined) return base;
  if (Array.isArray(patch)) return patch as T;
  if (typeof patch !== 'object' || patch === null) return patch as T;
  if (typeof base !== 'object' || base === null || Array.isArray(base)) return patch as T;

  const out = { ...(base as Record<string, unknown>) };
  for (const key of Object.keys(patch as object)) {
    const pv = (patch as Record<string, unknown>)[key];
    const bv = (base as Record<string, unknown>)[key];
    if (pv === undefined) continue;
    if (Array.isArray(pv)) {
      out[key] = pv;
    } else if (pv !== null && typeof pv === 'object') {
      out[key] =
        bv !== null && typeof bv === 'object' && !Array.isArray(bv)
          ? mergePublicLocale(bv as T, pv)
          : pv;
    } else {
      out[key] = pv;
    }
  }
  return out as T;
}
